import React from 'react';
import AdSense from 'react-adsense';

class AdErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Prevent AdSense DOM mutation errors (e.g. "The node to be removed is not a child of this node")
        // and tag errors from crashing the page
        if (typeof console !== 'undefined' && console.warn) {
            console.warn('[AdSenseBlock] Caught ad error, preserved page integrity:', error && error.message);
        }
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}

export default function AdSenseBlock(props) {
    return (
        <AdErrorBoundary>
            <AdSense.Google {...props} />
        </AdErrorBoundary>
    );
}
